export default function deleteButton(params: any) {

  return `<Button class='btn btn-destructive segments-grid-delete-button'>Delete</Button>`;
};
